<section>
    <div class="wrapper">
        <article class="mrt-75">
            <div class="site-list-component">
                <mat-grid-list cols="1" rowHeight="70px" class="header-grid">
                    <mat-grid-tile>
                        <span class="header">Inactive Sites List</span>
                    </mat-grid-tile>
                </mat-grid-list>
            </div>
            <div class="site-list-table">
                <div class="mat-elevation-z8 table-pagination">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortActive="created"
                        matSortDisableClear matSortDirection="desc">
                        <!-- Id Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef> Potential ID </th>
                            <td mat-cell *matCellDef="let element"> {{element?.vtigerPotentialId}} </td>
                        </ng-container>

                        <!-- Site name Column -->
                        <ng-container matColumnDef="potentialName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Site Name </th>
                            <td mat-cell *matCellDef="let element"> {{element?.potentialName}} </td>
                        </ng-container>

                        <!-- Unit ID Column -->
                        <ng-container matColumnDef="unitId">
                            <th mat-header-cell *matHeaderCellDef> Unit ID </th>
                            <td mat-cell *matCellDef="let element; let i= index;">{{element?.unitId}} </td>
                        </ng-container>

                        <!-- Unit Type Column -->
                        <ng-container matColumnDef="unitType">
                            <th mat-header-cell *matHeaderCellDef> Unit Type </th>
                            <td mat-cell *matCellDef="let element; let i= index;"> {{element?.unitType}} </td>
                        </ng-container>

                        <!-- Status Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let element; let i= index;"> {{element?.status}} </td>
                        </ng-container>

                        <!-- View Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef> Action </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="action-btn">
                                    <button mat-raised-button class="remove-btn" color="warn" matTooltip="Delete Site"
                                        (click)="deleteCancelledSite($event, element)">
                                        <mat-icon aria-hidden="false" aria-label="delete icon">delete</mat-icon>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                        </tr>
                    </table>
                    <div class="no_record_found_msg" *ngIf="dataSource.data.length === 0">
                        No Records Found!
                    </div>
                    <mat-paginator #paginator class="hide-ripple" [pageSizeOptions]="[10, 25, 100]"
                        [pageSize]="pageSize" [length]="totalRecords" [pageIndex]="pageNumber"
                        (page)="changePaging($event)" aria-label="Select page of users">
                    </mat-paginator>
                </div>
            </div>
        </article>
    </div>
</section>